import LxcError from "~/core/models/LxcError.class";
import type { UseFetchParameters } from "~/core/models/UseFetchParameters.type";
import type { DtwinExistingConnectivityStatus } from "~/modules/dtwin/models/DtwinExistingConnectivityStatus.interface";
import dtwinsService from "~/modules/dtwin/services/dtwin.service";

export function useFetchDtwinConnectivityStatus({
  organizationCode,
}: UseFetchParameters) {
  const results: Ref<DtwinExistingConnectivityStatus | undefined> = ref();
  const error: Ref<LxcError | undefined> = ref();
  const isLoading: Ref<boolean> = ref(false);

  async function fetchAll() {
    isLoading.value = true;

    if (!organizationCode) {
      throw new Error("Organization code is undefined");
    }
    const response =
      await dtwinsService.getDtwinsConnectivityStatus(organizationCode);

    if (LxcError.check(response)) {
      results.value = undefined;
      error.value = response;
    } else {
      error.value = undefined;
      results.value = response;
    }

    isLoading.value = false;
  }

  return {
    results,
    isLoading,
    error,
    fetchAll,
  };
}
